<template>
  <div class="continar">
    <h1>404</h1>
    <div>找不到网页!</div>
    <div>对不起，您正在寻找的页面不存在。请联系系统管理员。</div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.querySelector('#app').style.width = '100%'
    document.querySelector('#app').style.height = '100%'
  },
}
</script>

<style scoped>
#app {
  width: 100%;
  height: 100%;
}
h1 {
  color: #676a6c;
  font-size: 130px;
  display: flex;
  justify-content: center;
  margin: 0 !important;
}

body,
html {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5 !important;
}
.continar {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
.continar div {
  display: flex;
  justify-content: center;
}
</style>
